import { Chip } from '@mui/material';

const InterestMethodTag = ({ item }) => {
    if (!item) return null;
    const label = item?.is_compound ? `Compound${item?.compounding_frequency ? ` (${item.compounding_frequency})` : ''}` : 'Simple';
    return <Chip label={label} size="small" color={item?.is_compound ? 'secondary' : 'primary'} variant="outlined" sx={{ fontSize: '10px', mt: 0.5, height: '17px', fontWeight: 'bold' }} />;
}
export default InterestMethodTag;
